/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function PlusSquareIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M10 9c-.562 0-1 .5-1 1v20c0 .563.438 1 1 1h20c.5 0 1-.437 1-1V10c0-.5-.5-1-1-1zm-4 1c0-2.187 1.75-4 4-4h20c2.188 0 4 1.813 4 4v20c0 2.25-1.812 4-4 4H10c-2.25 0-4-1.75-4-4zm12.5 15.5v-4h-4c-.875 0-1.5-.625-1.5-1.5 0-.812.625-1.5 1.5-1.5h4v-4c0-.812.625-1.5 1.5-1.5.813 0 1.5.688 1.5 1.5v4h4c.813 0 1.5.688 1.5 1.5 0 .875-.687 1.5-1.5 1.5h-4v4c0 .875-.687 1.5-1.5 1.5-.875 0-1.5-.625-1.5-1.5"/>}
        </IconWrapper>);
}
